import { IPersonaProps } from 'office-ui-fabric-react';

export interface IHorizontalPersonaProps extends IPersonaProps {
  vertical?: false;
}
